export default function R_Arrays() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Arrays Component</h1>
      <p>This is the R_Arrays tutorial section.</p>
    </div>
  );
}
